export default "/images/4e5ae4d265f001bbaaccae1849b2f7e6.avif";